class t{constructor(t){this._events=[...t],this._events.sort(((t,e)=>t.time-e.time))}get events(){return this._events}}export{t as AnimEvents};
